/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum FinnairItineraryItemType {
  FLIGHT = 'FLIGHT',
  LAYOVER = 'LAYOVER'
}

